<template>
    <div>
    <!-- Edit Or Delete Visit -->
    <!-- <b-modal
      :id="'edit_delete_visit_modal' + dailyLogData.visit_id"
      scrollable
      hide-header
      hide-footer
      size="md"
      no-close-on-esc
      :ref="'edit_delete_visit_modal' + dailyLogData.visit_id"
      @hide="resetReason"
    > -->
      <div class="modal-topheader">
        <div class="modal-toptitle">
          <p class="modal-title">
            {{ isEditVisit ? $t("common.edit") : $t("common.delete") }} {{ $t("common.expectedVisit") }}
          </p>
        </div>
      </div>

      <div style="margin-bottom: 29px" v-if="isEditVisit">
        <div class="date-piker-wrapper">
          <div class="date-time-wrappers date-p">
            <date-picker
              id="visit_date"
              class="pre-reg-datepicker"
              :class="dateValidation ? 'is-invalid' : ''"
              :first-day-of-week="1"
              v-model="dateValue"
              placeholder="Visit Date"
              value-type="date"
              format="DD/MM/YYYY"
              :disabledDate="disableDateBeforeCurrent"
              @change="handleTimeChange"
            >
              <i slot="icon-calendar" v-if="!dateValue">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                    fill="#787878"
                  />
                </svg>
              </i>
              <i slot="icon-calendar" v-if="dateValue">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                    fill="#103F5E"
                  />
                </svg>
              </i>
            </date-picker>
          </div>
          <div class="date-time-wrappers">
            <date-picker
              id="visit_time"
              class="pre-reg-datepicker"
              :class="timeValidation ? 'is-invalid' : ''"
              :use12h="true"
              :show-second="false"
              format="hh:mm A"
              v-model="timeValue"
              value-type="date"
              type="time"
              :open.sync="open"
              placeholder="Visit Time"
              @change="handleTimeChange"
              :disabled="!dateValue && !timeValue"
              :disabledTime="disableTimeBeforeCurrent"
              :hour-options="availableHours"
              :minute-options="availableMinuts"
            >
              <i slot="icon-calendar" v-if="!timeValue">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                    fill="#787878"
                  />
                </svg>
              </i>
              <i slot="icon-calendar" v-if="timeValue">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                    fill="#103F5E"
                  />
                </svg>
              </i>
            </date-picker>
          </div>
        </div>
        <p class="timezone-msg">
          <span style="font-weight: 700">Note:</span> Selected visit time is set
          to ({{ preRegTimeZone }}) time zone.
        </p>
        <p v-if="timeValidation && dateValidation" class="time-error">
          {{ $t('preRegisteration.visitDateTimeInvalid') }}
        </p>
        <p v-else-if="timeValidation" class="time-error">
          {{ $t('addExpectedVisitor.visitTimeCantBeforeNow')}}
        </p>
        <p v-else-if="dateValidation" class="time-error">
         {{ $t('preRegisteration.visitDateTimeInvalidToday') }}
        </p>
      </div>

      <div class="visit-permissions" v-else>
        <p class="normal-txt">
          {{ $t('common.notes.areYouSureYouWant') }}
          <strong class="strong-txt">“{{ $t('common.delete') }}”</strong> {{ $t('common.notes.expectedVisitOf', { fullName: fullName }) }}
        </p>
        <span class="normal-txt">{{ $t('common.notes.ifYesPleaseSpecifyTheReason') }}</span>
      </div>

      <div>
        <b-form-group class="reason-textbox">
          <b-form-textarea
            id="notes"
            v-model="changeVisitReason"
            class="form-control visitNotesText"
            @keyup="editVisitNotesChanged($event)"
            type="text"
            :placeholder="$t('common.reason')"
            rows="5"
            no-resize
            maxlength="255"
          ></b-form-textarea>
        </b-form-group>
        <div class="msg-con">
          <p class="length-msg">
            <b>{{ $t("common.notes.note") }}: </b>{{ $t("common.validation.reasonMustBeAtLeast20Characters") }}
          </p>
        </div>

        <hr
          class="question-divider"
          style="margin: 40px auto 0px auto; width: 415px"
        />
      </div>

      <div v-if="isEditVisit" class="actions-btns">
        <b-button
          @click="editVisit()"
          variant="primary"
          type="button"
          pill
          class="text-center"
          :disabled="
            !changeVisitReason ||
            changeVisitReason.length < 20 ||
            !checkValidation ||
            isLoading
          "
        >
          <i
            v-if="isLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span>{{ $t("common.save") }}</span>
        </b-button>

        <b-button
          @click="$bvModal.hide(modalIdVal)"
          variant="outline-danger"
          type="button"
          pill
          class="text-center"
          :disabled="isLoading"
        >
          <i
            v-if="isLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span>{{ $t("common.cancel") }}</span>
        </b-button>
      </div>

      <div v-else class="actions-btns">
        <b-button
          variant="primary"
          type="button"
          pill
          class="text-center"
          :disabled="isLoading"
          @click="
          $bvModal.hide(modalIdVal),
              resetReason()
          "
        >
          <span>{{ $t("common.cancel") }}</span>
        </b-button>

        <b-button
          variant="outline-danger"
          type="button"
          pill
          class="text-center"
          :disabled="
            !changeVisitReason || changeVisitReason.length < 20 || isLoading
          "
          @click="editVisit()"
        >
          <i
            v-if="isLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span>{{ $t("common.delete") }}</span>
        </b-button>
      </div>
    <!-- </b-modal> -->

    </div>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";



export default {
  props: ["dailyLogData", "modalIdType"],
  data() {
    return {
      modalLoading: null,
      items: [],
      open: false,
      changeVisitReason: "",
      isLoading: false,
      visitModalTitle: "",
      visitData: null,
      isEditVisit: 0,
      manageVisit: null,
      fullName: "",
      dateValue: null,
      timeValue: null,
      offset: null,
      daysDiff: null,
      preRegTimeZone: null,
      dateValidation: false,
      timeValidation: false,
      checkValidation: false,
      firstName: "",
      lastName: "",
      visitRejected: false,
      visitApproved: false,
      scan_time: null,
      rejectionReason: null,
      action_by: null,
      userTypeId: "",
      id: "",
      areaId: "",
      visitId: null,
      visitNotesCopy: "",
      isDisabled: false,
    };
  },

  computed: {
    ...mapGetters("preRegistration", [
      "getVisitApproved",
      "getVisitRejected",
      "getApproveVisit",
      "getRejectVisit",
    ]),

    availableHours: function () {
      let todayDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.preRegTimeZone,
        })
      );
      let dateString = todayDate.toISOString().slice(0, 10);
      this.dateValue?.setHours(12);
      if (this.dateValue?.toISOString().slice(0, 10) === dateString) {
        let cTime = todayDate.getHours();
        const arr = this.range(cTime, 23);
        const hrsArr = [];
        arr.map((hours) => {
          if (!hrsArr.includes(hours % 12))
            hrsArr.push(hours % 12 ? hours % 12 : 0);
        });
        return hrsArr;
      }
      return this.range(0, 23);
    },

    availableMinuts: function () {
      let todayDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.preRegTimeZone,
        })
      );
      let dateString = todayDate.toISOString().slice(0, 10);
      if (this.dateValue?.toISOString().slice(0, 10) === dateString) {
        let cTime = todayDate.getHours();
        let selectedHour = this.timeValue?.getHours();
        if (cTime === selectedHour) {
          return this.range(todayDate.getMinutes() + 5, 59);
        }
      }
      return this.range(0, 59);
    },
  },

  beforeMount() {
    console.log("this.dailyLogData", this.dailyLogData);
    if(this.dailyLogData){
      
      if(this.modalIdType == 'string') this.modalIdVal = 'delete_expected_visit_modal';
      else this.modalIdVal = 'delete_expected_visit_modal'+this.dailyLogData.visit_id;

      this.visitData = this.dailyLogData;
      const expectedVisit = this.visitData.Data.isExpectedScanExist || this.visitData.Data.isNoShowScanExist;
      if (this.isEdit) this.checkValidation = false;
      this.fullName = this.visitData.FullName;
      this.preRegTimeZone = this.visitData.site_timezone;

      let utcDate = new Date(
        new Date().toLocaleString("en-US", { timeZone: "UTC" })
      );
      let tzDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.preRegTimeZone,
        })
      );
      this.offset = utcDate.getTime() - tzDate.getTime();

      this.dateValue = new Date(
        moment
          .utc(expectedVisit.scan_time)
          .tz(this.visitData.site_timezone)
          .format("YYYY-MM-DD HH:mm:ss")
      );

      this.timeValue = new Date(
        moment
          .utc(expectedVisit.scan_time)
          .tz(this.visitData.site_timezone)
          .format("YYYY-MM-DD HH:mm:ss")
      );
    }

      //   console.log("date0", this.dateValue, this.timeValue);
  },

  watch: {
    getRejectVisit(value) {
      if (value) {
        this.visitModalTitle = "Reject Visit Request";
      } else {
        this.visitModalTitle = this.manageVisit
          ? "Manage Visit"
          : "Fill in Compliance";
      }
    },
  },

  methods: {
    ...mapActions("preRegistration", [
      "setVisitApproved",
      "setVisitRejected",
      "setApproveVisit",
      "setRejectVisit",
      "editExpectedVisit",
      "deleteExpectedVisit",
    ]),
    ...mapActions("compliance", [
      "fetchUserCompliance",
      "selectComplianceCreated",
      "setModalClosed",
    ]),
    ...mapActions("sites", ["fetchAreaDocument"]),

    hideModal(id) {
      this.$bvModal.hide(id);
    },
    resetReason() {
      this.changeVisitReason = "";
    },
    openVisitNotes(visit_id, visitNotes) {
      this.visitNotes = this.visitNotesCopy =
        visitNotes !== "-" ? visitNotes : "";
      if (!this.visitNotes) this.isDisabled = true;
      this.visit_id = visit_id;
      this.$bvModal.show("visitNotes" + visit_id);
    },

    visitNotesChanged(e) {
      // console.log('visitNotesChanged', e.target.value);
      this.visitNotes = e.target.value;
      if (!e.target.value) this.isDisabled = true;
      else this.isDisabled = false;
    },

    editVisitNotesChanged() {
      // console.log('visitNotesChanged', e.target.value);
      this.handleTimeChange();
    },

    addVisitNotes() {
      // console.log(this.visit_id, this.visitNotes, this.visitNotesCopy);
      if (!this.visitNotes) return;
      this.$store.dispatch("dailyLogbook/addVisitNotes", {
        visit_id: this.visit_id,
        notes: this.visitNotes,
      });
      this.$bvModal.hide("visitNotes" + this.visit_id);
    },
    editVisit() {
      if (this.isEditVisit) {
        let todayDate = new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.preRegTimeZone,
          })
        );
        let selectedDateTime = this.dateValue;
        selectedDateTime?.setHours(
          this.timeValue?.getHours(),
          this.timeValue?.getMinutes(),
          this.timeValue?.getSeconds()
        );

        // date validations
        if (
          (!this.dateValue && this.timeValue) ||
          (this.dateValue &&
            moment(new Date(this.dateValue)).format("YYYY-MM-DD") <
              moment(todayDate).format("YYYY-MM-DD"))
        ) {
          // this.checkValidation = false;
          this.dateValidation = true;
        }

        // time validation
        if (this.dateValue && !this.timeValue) {
          // this.checkValidation = false;
          this.timeValidation = true;
        }
        // let dateString = todayDate.toISOString().slice(0, 10);
        if (
          moment(new Date(this.dateValue)).format("YYYY-MM-DD") <=
          moment(todayDate).format("YYYY-MM-DD")
        ) {
          let cHours = todayDate.getHours();
          let cMinutes = todayDate.getMinutes() + 5;
          if (cHours === this.timeValue?.getHours()) {
            if (this.timeValue?.getMinutes() < cMinutes) {
              // this.checkValidation = false;
              this.timeValidation = true;
            }
          } else if (this.timeValue?.getHours() < cHours) {
            // this.checkValidation = false;
            this.timeValidation = true;
          }
        }

        if (this.dateValidation || this.timeValidation) return;

        // console.log(
        //   moment.utc(new Date(this.dateValue)).format("YYYY-MM-DD"),
        //   moment.utc(this.timeValue).format("HH:mm:ss")
        // );

        const selectedDateStamp = Date.parse(
          moment(this.dateValue).format("YYYY-MM-DD")
        );
        let selectedDate;
        if (this.daysDiff != 0)
          selectedDate = new Date(
            selectedDateStamp - this.daysDiff * 24 * 60 * 60 * 1000
          );
        const finalDate = this.daysDiff != 0 ? selectedDate : this.dateValue;
        const utcTime = new Date(this.timeValue);
        utcTime.setTime(this.timeValue.getTime() + this.offset);
        const finalTime = utcTime;

        // console.log("final", finalDate, finalTime);
        this.isLoading = true;
        this.editExpectedVisit({
          visit_id: this.visitData.visit_id,
          entity_id: this.visitData.entity_id,
          visit_date: moment(finalDate).format("YYYY-MM-DD"),
          visit_time: moment(finalTime).format("HH:mm:ss"),
          notes: this.changeVisitReason,
        })
          .then(() => {
            this.$bvModal.hide(
              this.modalIdVal
            );
            this.isLoading = false;
            this.changeVisitReason = "";
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.isLoading = true;
        this.deleteExpectedVisit({
          visit_id: this.visitData.visit_id,
          entity_id: this.visitData.entity_id,
          notes: this.changeVisitReason,
        })
          .then(() => {
            this.$bvModal.hide(
              this.modalIdVal
            );
            this.isLoading = false;
            this.changeVisitReason = "";
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },

    range(start, end) {
      return Array.from({ length: end - start + 1 }, (_, i) => i + start);
    },

    handleTimeChange() {
      this.timeValidation = false;
      this.dateValidation = false;
      const { dateValue, timeValue, changeVisitReason } = this;
      if (dateValue && timeValue && changeVisitReason) {
        this.checkValidation = true;
      } else {
        this.checkValidation = false;
      }

      const utcTime = new Date(this.timeValue);
      utcTime.setTime(this.timeValue.getTime() + this.offset); // today date utc
      const dateDiff =
        Date.parse(moment(new Date(this.timeValue)).format("YYYY-MM-DD")) -
        Date.parse(moment(utcTime).format("YYYY-MM-DD"));
      this.daysDiff = dateDiff / (60 * 60 * 24 * 1000);
    },

    disableDateBeforeCurrent(date) {
      let cDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.preRegTimeZone,
        })
      );
      let currentYear = cDate.getFullYear();
      let currentMonth = cDate.getMonth();
      let currentDay = cDate.getDate();
      return date < new Date(currentYear, currentMonth, currentDay);
    },
    disableTimeBeforeCurrent(date) {
      const time = new Date(
        new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.preRegTimeZone,
          })
        ).getTime() +
          5 * 60000
      );
      const after5Mins = moment(new Date(time)).format("HH:mm:ss");
      const todayDate = moment(
        new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.preRegTimeZone,
          })
        )
      ).format("YYYY-MM-DD");
      const selectedTime = moment(new Date(date)).format("HH:mm:ss");
      return (
        moment(new Date(this.dateValue)).format("YYYY-MM-DD") == todayDate &&
        selectedTime < after5Mins
      );
    },
  },
};
</script>
<style lang="scss" scoped>
button.custom-signinout {
  margin-inline-start: 16px !important;
}
.visit-note-action-btns {
  display: flex;
  justify-content: space-between;
  width: 255px;
  margin: auto;

  button {
    width: 112px;
    height: 33px;
  }
}
</style>
<style lang="scss">
.reason-textbox div {
  width: 416px;
  justify-self: center;
}
button.btn.text-center.mt-2.px-5.mr-2.save-visit-note.btn-primary.rounded-pill:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed;
}
div[id*="compFillIn_modal"] {
  min-width: 491px !important;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  div[class*="modal-content"] {
    z-index: 1001;
  }
}
.visitNotesText {
  inset-inline-start: 32.99%;
  inset-inline-end: 33.12%;
  top: 42.67%;
  bottom: 43.56%;
  background-color: #f2f2f2 !important;
  border-color: #f2f2f2 !important;
  border-radius: 4px !important;
}

.timezone-msg {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: start;
  letter-spacing: 0.25px;
  color: #939393;
  margin-top: 16px;
  margin-inline-start: 40px;
  margin-bottom: 0px !important;
}
.is-invalid {
  border: 1.5px solid #f46a6a;
  border-radius: 4px;
}
.date-time-lable {
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.25px;
  color: #787878;
  text-align: start;
  margin-bottom: 31px;
  padding-inline-start: 53px;
}
.date-piker-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.time-error {
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0.25px;
  text-align: center;
  color: #f46a6a;
  margin-top: 20px;
}
.date-p {
  margin-inline-end: 15px;
}
.date-time-wrappers {
  width: 200px !important;
  height: 55px !important;

  .selected-date-lable {
    margin-bottom: -3px;
    text-align: start;
    background-color: #f2f2f2;
    padding-top: 8px;
    padding-inline-start: 12px;
    font-size: 10px;
    font-weight: 700;
    color: #103f5e;
  }
  .invaled-top-half {
    border: 1.5px solid #f46a6a;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
  }
}
.visit-permissions .strong-txt {
  color: #939393;
  font-weight: 700;
  font-size: 16px;
  line-height: 30.1px;
}
.dashboard-actions-seperator {
  border-bottom: 1px solid #e0e0e0 !important;
}
.visit-permissions {
  font-weight: 400;
  font-size: 20px;
  line-height: 38px;
  text-align: center;
  width: 380px !important;
  color: #787878;
  margin: 0px auto 8px auto;
  p {
    margin: 0px !important;
    padding: 0px !important;
  }
}
.actions-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 33px;
  button.btn.text-center.btn-primary.rounded-pill {
    width: 112px;
    height: 33px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-end: 15px;
    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      color: #ffffff;
    }
  }
  .btn-primary.disabled {
    opacity: 0.4 !important;
    cursor: not-allowed;
  }
  button.btn.text-center.btn-outline-danger.rounded-pill {
    width: 111px;
    height: 33px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-start: 15px;
    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      :hover {
        background: #f46a6a !important;
        color: #ffffff !important;
      }
    }
  }
}
div[id*="delete_expected_visit_modal"] {
  div[id*="___BV_modal_content_"] {
    div[id*="___BV_modal_body_"] {
      padding: 0px !important;
      p.modal-title {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        color: #000000;
        margin-inline-start: 45px;
        text-align: start;
        margin-bottom: 44px;
        margin-top: 41px;
      }
      .form-group {
        margin-bottom: 8px !important;
      }
      .msg-con {
        width: 416px;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        p.length-msg {
          font-weight: 400;
          font-size: 14px;
          margin-bottom: 0px !important;
          line-height: 22px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #939393;
        }
      }
      .normal-txt {
        font-weight: 400;
        font-size: 16px;
        line-height: 30.1px;
        text-align: center;
        margin-bottom: 36px;
        color: #787878;
      }
      p.time-error {
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        letter-spacing: 0.25px;
        margin-top: 18px;
        margin-bottom: 18px;
        color: #f46a6a;
      }
      input.mx-input::placeholder {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        margin-inline-start: 20px;
        padding-inline-start: 10px;
        color: #787878;
      }
      .actions-btns {
        margin-bottom: 21px !important;
      }
    }
  }
}

.dropdown-wrapper {
  padding: 0;

  .dropdown-items {
    font-weight: 400;
    font-size: 16px !important;
    text-align: center;
    line-height: 19px !important;
    color: #787878;
    margin: 12px auto !important;
    max-width: 142px !important;
    white-space: normal !important;
    padding: 1px 5px 1px 5px !important;
  }

  .red-remove {
    color: #f46a6a !important;
  }
}

.dx-scrollable-scroll.dx-state-invisible,
.dx-scrollable-scroll-content {
  background: #666666 !important;
  border-radius: 8.5px !important;
}
.dx-scrollable-scrollbar.dx-widget.dx-scrollbar-vertical.dx-scrollbar-hoverable {
  background: #ededed !important;
  border-radius: 8.5px !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}
</style>